module.exports = __webpack_public_path__ + "static/blue_background_gradient-c9b177840b57c4bd441345f64032575b.jpg";